// import TaskTypesLookup from "core/model2/project/inheritance/task-types";

import Project from "../../model2/project/project";
import Task from "../../model2/task/task";
import {ProjectSystemType} from "../../model2/project/types"
import ProjectSession from "../../model2/project/project-session"
import {ProjectTree} from "../../gd-model/tree/@type";

export default class StructureControl {

    // Access control
    // Nesting control
    // Business logics control

    static canCreate(destination:Project) {
        const { TAG } = gd.const.project.type;
        return gd.const.systemStatus.isOpen(destination.systemStatus) && destination.systemType !== TAG;
    }

    /******* TASK *********/

    static canMoveTask(task: Task) {
        let result = false;
        const parentId = task.parentId;
        if (parentId) {
            const project = gd.session.projects.get(parentId);
            if (project) {
                const isCompanyManager = gd.ac.check.company.isManager(project.companyId);
                const isParentProjectManager = parentId ? gd.ac.check.project.standardAccess(parentId) : false;

                result = isCompanyManager || isParentProjectManager;
            }
        }

        return result;
    }

    static canMoveTaskIntoTask(task:Task, hasChildren:boolean, destination:Task, options = {
        allowMoveToTaskParent: false
    }) {
        const { allowMoveToTaskParent } = options;
        let result = false;

        const moveOpen = gd.const.systemStatus.isOpen(task.systemStatus);
        const targetClosed = gd.const.systemStatus.isClosed(destination.systemStatus);

        const parentId = destination.parentId;
        let hasAccess = true;
        if (parentId) {
            const project = gd.session.projects.get(parentId);
            hasAccess = project ? gd.ac.check.project.standardAccess(parentId) : false;
        }

        if (hasAccess &&
            task.id !== destination.id &&
            (allowMoveToTaskParent || task.parentTaskId !== destination.id) &&
            !(targetClosed && moveOpen)){
            result = destination.systemType !== gd.const.taskSystemType.SUBTASK
                    && !hasChildren;
        }

        return result;
    }

    static canMoveTaskIntoProject(task:Task, destination:Project): boolean {
        // const moveOpen = gd.const.systemStatus.isOpen(task.systemStatus)
        return /*moveOpen &&*/ (gd.session.projects.get(destination.id) as ProjectSession).acl.canCreateTask
    }

    /******* PROJECT *********/

    static canMoveProject(projectId:ID, parentProject?:Project|null):boolean {
        let result = false;
        if (projectId) {
            const project = gd.session.projects.get(projectId);
            if (project) result = gd.ac.check.project.fullAccess(project.id, project);
        }
        return result;
    }

    static canMoveProjectIntoProject(project:Project, destination:Project):boolean {
        let result = false

        const targetId  = destination.id
        const moveId    = project.id

        const isProjectAllowed = gd.session.projects.get(destination.id)!.acl.canCreateProject

        if (project.isWorkspace) { // workspaces can't be dropped into projects
            result = false
        } else if (isProjectAllowed) { //if create project is allowed then check further
            // const targetSType   = destination.systemType
            // const moveSType     = project.systemType

            // project system status is already checked in canCreateProject
            // const isTargetProjectClosed         = gd.const.systemStatus.isClosed(destination.systemStatus)
            // const isMovedProjectOpen            = gd.const.systemStatus.isOpen(project.systemStatus)
            // const isDropAllowedBySystemStatuses = !(isTargetProjectClosed && isMovedProjectOpen)            // should not move open item to closed

            const isMovedToItself               = targetId !== moveId                                       // should not be the same item

            if (isMovedToItself /*&& isDropAllowedBySystemStatuses*/) {
                const treeProjectParents    = gd.tree.findProjectParents(gd.tree.getProject(targetId))
                const isChildOfDraggedItem  = _.some(treeProjectParents, (p:Project)=>p.id === moveId)      // target item should not be a child of dragged item (moving to own child)

                result = !isChildOfDraggedItem

                /*if (!isChildOfDraggedItem) {
                    const folderLikeSystemTypes = [ProjectSystemType.FOLDER, ProjectSystemType.PAGE, ProjectSystemType.CATEGORY]
                    const isMovedProjectAllowedToDropIntoBacklogSprint = () => {
                        //only folderLikeSystemTypes are allowed to drop into this item
                        result = folderLikeSystemTypes.includes(moveSType)

                        //not allowed to drop here folderLikeSystemTypes that contains any project except folderLikeSystemTypes
                        if (result && folderLikeSystemTypes.includes(moveSType)){
                            const treeProjectChildren = gd.tree.findProjectChildren(moveId)
                            result = !_.some(treeProjectChildren, (p:Project)=>!folderLikeSystemTypes.includes(p.systemType))
                        }

                        return result
                    }

                    switch(targetSType) {
                        case ProjectSystemType.PROJECT  :
                            result = true // is always allowed to drop to project
                            break

                        case ProjectSystemType.FOLDER   :
                        case ProjectSystemType.PAGE     :
                        case ProjectSystemType.CATEGORY :
                            result = true

                            //check if current item has any parent of BACKLOG or SPRINT type projects
                            const hasParentSprintBacklog = _.some(treeProjectParents, (p:Project)=>[
                                ProjectSystemType.SPRINT,
                                ProjectSystemType.BACKLOG
                            ].includes(p.systemType))

                            if (hasParentSprintBacklog) {
                                result = isMovedProjectAllowedToDropIntoBacklogSprint()
                            }
                            break

                        case ProjectSystemType.BACKLOG  :
                        case ProjectSystemType.SPRINT   :
                            result = result = isMovedProjectAllowedToDropIntoBacklogSprint()
                            break
                    }
                }*/
            }
        }

        return result
    }

    /******* EVENT *********/

    static canMoveEvent(event:Event) {
        return gd.ac.check.event.canEditEvent(event)
    }

    static canMoveEventIntoProject(event:Event, destination:Project) {
        let result = false

        // check event access
        const canEdit = gd.ac.check.event.canEditEvent(event)

        //check project access
        const isProjectAllowed = gd.session.projects.get(destination.id)!.acl.canCreateEvent

        result = canEdit && isProjectAllowed

        //below checks are already done in canCreateEvent
        /*if (canEdit && isProjectAllowed) {
            const targetSType   = destination.systemType
            const targetClosed  = gd.const.systemStatus.isClosed(destination.systemStatus)

            //check if same item or move open item to closed
            if (!targetClosed) {
                switch (targetSType) {
                    case gd.const.project.type.TAG  :
                        result = false
                        break

                    default                         :
                        result = true
                        break
                }
            }
        }*/

        return result
    }

    /******* NEW OPTIONS *********/

    static newProjectOptions(destinationProjectId:ID) {
        const parentProject = gd.tree.getProject(destinationProjectId);

        let allowedProjectTypes : any[] = [];
        if (parentProject) {
            switch (parentProject.systemType) {
                case ProjectSystemType.PROJECT:
                case ProjectSystemType.FOLDER:
                case ProjectSystemType.CATEGORY:
                    allowedProjectTypes = [
                        ProjectSystemType.PROJECT,
                        ProjectSystemType.FOLDER,
                        ProjectSystemType.CATEGORY,
                        ProjectSystemType.BACKLOG,
                        ProjectSystemType.SPRINT,
                        ProjectSystemType.TAG,
                        ProjectSystemType.LINK,
                        ProjectSystemType.EMBED,
                        ProjectSystemType.PAGE,
                    ];
                    break;

                case ProjectSystemType.BACKLOG:
                case ProjectSystemType.SPRINT:
                    allowedProjectTypes = [ProjectSystemType.FOLDER];
                    break;

                case ProjectSystemType.TAG:
                case ProjectSystemType.LINK:
                case ProjectSystemType.EMBED:
                case ProjectSystemType.PAGE:
                    //do nothing
                    break;
            }

            // if any of the parents are ProjectSystemType.SPRINT or ProjectSystemType.BACKLOG
            // then only folder is allowed
            const projectParents = gd.tree.findProjectParents(parentProject);
            projectParents.map((p:ProjectTree)=>{if([
                ProjectSystemType.SPRINT,
                ProjectSystemType.BACKLOG
            ].includes(p.systemType)) {
                allowedProjectTypes = [ProjectSystemType.FOLDER]
            }});
        }

        return allowedProjectTypes;
    }

    // possible parent system types for specified item
    static newParentOptions(section:any) {
        switch(section){
            case ProjectSystemType.PROJECT  :
            case ProjectSystemType.BACKLOG  :
            case ProjectSystemType.SPRINT   :
            case ProjectSystemType.TAG      :
            case ProjectSystemType.CATEGORY :
                return [
                    ProjectSystemType.WORKSPACE,
                    ProjectSystemType.PROJECT,
                    ProjectSystemType.FOLDER,
                    ProjectSystemType.CATEGORY,
                    ProjectSystemType.PAGE,
                    ProjectSystemType.EMBED,
                ]

            case "meeting"                  :
            case "note"                     :
            case "event"                    :
            case "task"                     :
            case 'dashboard'                :
                return [
                    ProjectSystemType.WORKSPACE,
                    ProjectSystemType.PROJECT,
                    ProjectSystemType.FOLDER,
                    ProjectSystemType.BACKLOG,
                    ProjectSystemType.SPRINT,
                    ProjectSystemType.CATEGORY,
                ]

            case "report"                   :
            case "user"                     :
            case "tagFilter"                :
                return [
                    ProjectSystemType.WORKSPACE,
                    ProjectSystemType.PROJECT,
                    ProjectSystemType.FOLDER,
                    ProjectSystemType.BACKLOG,
                    ProjectSystemType.SPRINT,
                    ProjectSystemType.TAG,
                ]

            case ProjectSystemType.FOLDER   :
            case 'discussion'               :
                return [
                    ProjectSystemType.WORKSPACE,
                    ProjectSystemType.PROJECT,
                    ProjectSystemType.FOLDER,
                    ProjectSystemType.BACKLOG,
                    ProjectSystemType.SPRINT,
                    ProjectSystemType.CATEGORY,
                    ProjectSystemType.PAGE,
                    ProjectSystemType.EMBED,
                ]

            default                         :
                return [
                    ProjectSystemType.WORKSPACE,
                    ProjectSystemType.PROJECT,
                    ProjectSystemType.FOLDER,
                    ProjectSystemType.BACKLOG,
                    ProjectSystemType.SPRINT,
                    ProjectSystemType.CATEGORY,
                    ProjectSystemType.PAGE,
                    ProjectSystemType.EMBED,
                    ProjectSystemType.LINK,
                ]
        }
    }

    /******* CONVERT OPTIONS *********/
    static convertOptions(project?:Project) {

        const { PROJECT, WORKFOLDER, BACKLOG, SPRINT } = gd.const.project.type;

        return [PROJECT, WORKFOLDER, BACKLOG, SPRINT];


    }
}
